<app-content-container>
  <app-creators-banner [addButtonConfiguration]="addButtonConfiguration" />
  <app-creators-datatable
    data-testid="creators-datatable"
    [creators]="store.creators$()"
    [creatorsLoading]="store.creatorsLoading$()"
  />
</app-content-container>
